/** Nombre maximal de voitures sur une même case physique. */
export const MAX_TRACK_CELL_OCCUPANCY = 2;

/** Autres pilotes déjà présents avant d’y entrer (place pour soi inclus → max 2). */
export function isTrackCellOccupancyFull(otherCount: number): boolean {
  return otherCount >= MAX_TRACK_CELL_OCCUPANCY;
}

/** Case cible libre pour un déplacement sans dépassement (0 autre → 1 voiture après). */
export function canEnterEmptyTrackCell(otherCount: number): boolean {
  return otherCount < MAX_TRACK_CELL_OCCUPANCY - 1;
}

/**
 * Une seule autre voiture : le partage n’est autorisé qu’après un dépassement réussi.
 */
export function requiresOvertakeToEnter(otherCount: number): boolean {
  return otherCount > 0 && !isTrackCellOccupancyFull(otherCount);
}

export interface OccupyTrackCellOptions {
  /**
   * Manche d’ouverture : partage gratuit avec 1 occupant. Une case déjà pleine
   * (2) ne peut jamais être une destination finale (traversée gérée à part).
   */
  openingRound: boolean;
  /** Le déplacement en cours a réussi un dépassement contre l’occupant de cette case. */
  overtakeSucceeded: boolean;
}

/**
 * Peut-on s’installer sur la case (destination) pendant un déplacement ?
 * Max 2 voitures. Plein (2 autres) → jamais. Partage (1 autre) : gratuit en
 * ouverture, sinon seulement après dépassement réussi.
 */
export function canOccupyTrackCell(otherCount: number, options: OccupyTrackCellOptions): boolean {
  if (isTrackCellOccupancyFull(otherCount)) return false;
  if (canEnterEmptyTrackCell(otherCount)) return true;
  if (options.openingRound) return true;
  return options.overtakeSucceeded;
}
